import React from "react";
import classNames from "classnames";

import { makeStyles } from '@mui/styles';
import { AppBar } from '@mui/material';
import { Toolbar } from '@mui/material';
import { IconButton } from '@mui/material';
// core components
import Button from "components/CustomButtons/Button.js";
import { MenuItem } from '@mui/material';
import { Menu } from '@mui/material';
import { Switch } from '@mui/material';
import { FormControlLabel } from '@mui/material';
import { FormGroup } from '@mui/material'
import { CircularProgress } from '@mui/material';
import { Divider } from '@mui/material';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import styles from "assets/jss/material-dashboard-react/components/headerStyle.js";
import {fetch_retry} from "assets/jss/general.js";
import { useCookies } from 'react-cookie';
import { SvgIcon } from '@mui/material';
import { useToken } from "hooks/token.js";
import { useHistory } from "react-router-dom";

function PersonIcon(props) {
  return (
    <SvgIcon {...props}>
      <g stroke="#000" strokeWidth="2" fill="none" fillRule="evenodd">
        <path d="M15.709 6.51a5.505 5.505 0 1 1-11.012 0 5.505 5.505 0 0 1 11.012 0zM1.946 20.273a8.258 8.258 0 0 1 16.516 0"></path>
      </g>
    </SvgIcon>
  );
}

const useStyles = makeStyles(styles);

export default function Header(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const { color, user, loading } = props;
  const appBarClasses = classNames({
    [" " + classes[color]]: color
  });

  const [token, setToken] = useToken();
  let historyObj = useHistory();

  const handleChange = (event) => {
    if(!event.target.checked){
      localStorage.removeItem('token');
      localStorage.removeItem('pwd')
      event.target.checked = true
      historyObj.push("/")
    }
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    localStorage.removeItem('tabsValue');
    setAnchorEl(null);
  };

  function makeBrand() {
    var name;
    props.routes.map(prop => {
      if (window.location.href.indexOf(prop.layout + prop.path) !== -1) {
        name = props.rtlActive ? prop.rtlName : prop.name;
      }
      return null;
    });
    return name;
  }

  var home = (
    <div className={classes.logo}>
      <a
        href="https://thermofisher.com"
        className={classNames(classes.logoLink, {
          [classes.logoLinkRTL]: props.rtlActive
        })}
        target="_blank"
      >
        <div className={classes.logoImage}>
          <img src={props.logoHome} alt="logoHome" className={classes.homeImg} />
        </div>
      </a>
    </div>
  );

  var brand = (
    <div className={classes.logo}>
      <a
        href="https://thermofisher.com"
        className={classNames(classes.logoLink, {
          [classes.logoLinkRTL]: props.rtlActive
        })}
        target="_blank"
      >
        <div className={classes.logoImage}>
          <img src={props.logo} alt="logo" className={classes.img} />
        </div>
      </a>
    </div>
  );

  return (
    <AppBar className={classes.appBar + appBarClasses}>
      <Toolbar className={classes.container}>
        <div className={classes.flex}>
          {/* Here we create navbar brand, based on route name */}
          <Button color="transparent" href="#" className={classes.title}>
            {home}{brand}
          </Button>
        </div>
        <div>
          <IconButton
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenu}
            color="inherit"
          >
            <PersonIcon />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={open}
            onClose={handleClose}
          >
            {(() => {
              if (loading) {
                return (<CircularProgress />);
              } else {
                return (
                    [
                      <Divider key="menuDivider"/>,
                      <MenuItem key="logout" onClick={handleClose}>
                        <FormGroup>
                          <FormControlLabel
                            control=<Switch checked={token ? true : false} onChange={handleChange} aria-label="login switch" />
                            label={token ? 'Logout' : 'Login'}
                            />
                        </FormGroup>
                      </MenuItem>
                    ]
                );
              }
            })()}
          </Menu>
        </div>
      </Toolbar>
    </AppBar>
  );
}
